import { ChangeDetectionStrategy, Component, inject, input, OnChanges, output } from '@angular/core';
import { EmployeeDto, StatusGroup } from '@app/_api/dto';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { SelectOptionGroup } from '@app/_api/model';
import { StatusGroupUtil } from '@app/shared/utils/status-group.util';
import { MultiSelectComponent } from '@app/shared/components/multi-select/multi-select.component';

@Component({
  selector: 'if-multi-select-status-group',
  templateUrl: './multi-select-status-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MultiSelectComponent],
})
export class MultiSelectStatusGroupComponent implements OnChanges {
  readonly selectChange = output<StatusGroup[]>();
  readonly showSelectAll = input(true);
  readonly showHeader = input(true);
  readonly multiSelectMaxHeight = input<string>();
  readonly isOpen = input(false);
  selectedVisibilityGroups: StatusGroup[] = [];
  disabledPreselectedGroups: StatusGroup[] = [];
  allStatusGroups: SelectOptionGroup<StatusGroup>[] = [];
  employee!: EmployeeDto;
  isConsultant!: boolean;
  myStatusGroupLabels: string[] = [];
  private readonly employeeDataService = inject(EmployeeDataService);
  private readonly statusGroups: StatusGroup[] | undefined = undefined;

  constructor() {
    this.statusGroups = this.employeeDataService.allStatusGroups();
  }

  ngOnChanges() {
    this.employee = this.employeeDataService.employee()!;
    this.myStatusGroupLabels = this.employee.statusGroups.map(statusGroup => statusGroup.name);
    this.selectedVisibilityGroups = structuredClone(this.employee.visibilityGroups);

    this.allStatusGroups = StatusGroupUtil.asOptionGroups(this.statusGroups!);
  }
}
